/**
 * Copyright Mántum All Rights Reserved.
 */
type Prototype = {
    testid?: string;
};

export default function Skeleton(props: Prototype) {
    return (
        <div
            className=' flex w-full animate-pulse space-x-4'
            aria-label='Loading'
            data-testid={props.testid}
        >
            <div className='flex-1'>
                <div className='h-10 rounded bg-slate-200'></div>
            </div>
        </div>
    );
}
